import React from "react";
import { connect } from "react-redux";
import { IonContent } from "@ionic/react";
import AppHeader from "components/Header/AppHeader";
import ScoringRounds from "./Rounds";

interface props {
  teams: any;

}

const Scoring: React.FC<props> = (teams) => {
  return (
    <>
      <AppHeader title="Scoring" />
      <IonContent fullscreen className="ion-padding dashboard">
        <div className="container">
          <ScoringRounds />
        </div>
      </IonContent>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  teams: state.teams,
});

export default connect(mapStateToProps, {})(Scoring);
